import { DEFAULT_THEME } from "@mantine/core";

import { CustomTheme } from "./interface";

export const radius: CustomTheme["radius"] = {
  ...DEFAULT_THEME.radius,
  xs: "4px",
  sm: "5px",
  md: "6px",
};
